import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(12)};
  color: ${({ theme }) => theme.font.color.tertiary};
  font-size: ${({ theme }) => theme.font.size.md};
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const LoadingText = styled.p`
  color: ${({ theme }) => theme.font.color.tertiary};
  padding: ${({ theme }) => theme.spacing(8)};
  text-align: center;
`;

type AlertVariant = 'error' | 'success' | 'warning';

interface AlertBannerProps {
  variant?: AlertVariant;
}

export const AlertBanner = styled('div', {
  shouldForwardProp: prop => isPropValid(prop) && prop !== 'variant'
})<AlertBannerProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(3, 4)};
  border-radius: ${({ theme }) => theme.border.radius.md};
  margin-bottom: ${({ theme }) => theme.spacing(5)};
  font-size: ${({ theme }) => theme.font.size.sm};

  ${({ variant = 'error', theme }) => {
    switch (variant) {
      case 'success':
        return `
          background: ${theme.color.green}1A;
          border: 1px solid ${theme.color.green};
          color: ${theme.color.green};
        `;
      case 'warning':
        return `
          background: ${theme.color.yellow}1A;
          border: 1px solid ${theme.color.yellow};
          color: ${theme.color.yellow};
        `;
      default:
        return `
          background: ${theme.background.danger};
          border: 1px solid ${theme.color.red};
          color: ${theme.color.red};
        `;
    }
  }}
`;

export const CodeBlock = styled.pre`
  background: ${({ theme }) => theme.background.secondary};
  border: 1px solid ${({ theme }) => theme.border.color.light};
  border-radius: ${({ theme }) => theme.border.radius.sm};
  padding: ${({ theme }) => theme.spacing(3)};
  font-size: ${({ theme }) => theme.font.size.xs};
  overflow-x: auto;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-all;
`;

export const MutedText = styled.span`
  color: ${({ theme }) => theme.font.color.tertiary};
  font-size: ${({ theme }) => theme.font.size.sm};
`;

export const InlineCode = styled.code`
  font-size: ${({ theme }) => theme.font.size.sm};
  background: ${({ theme }) => theme.background.tertiary};
  padding: ${({ theme }) => theme.spacing(0.5, 1)};
  border-radius: ${({ theme }) => theme.border.radius.xs};
`;
